<template>
<div :class="['micad_formElement micad_formElement_readOnly',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        {{content}}
    </div>
</div>
</template>

<script>
export default {
  name: 'Read only',
  data() {
    return {
        label: "Quisque tristique.",
        content: "Quisque tristique quis leo vitae luctus.",
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
